import { css, Theme } from "@/theme";
import { DataGrid, DataGridProps, GridRowClassNameParams } from "@mui/x-data-grid";


const gridStyles = {
  table: (theme: Theme) => css`
  border: 1px solid ${theme.palette.primary[100]};

  .MuiDataGrid-iconSeparator {
    display: none;
  }
  .MuiDataGrid-columnHeader{
    padding: 16px;
    color: #747474;

    font-family: ${theme.typography.h5.fontFamily};
    font-size: 14px;
    font-weight: 700;
    line-height: 120%;
    text-transform: uppercase;
  }
  .MuiDataGrid-columnHeader:last-child{
    border-right: 0;
  }
  .MuiDataGrid-columnHeader, .MuiDataGrid-cell {
    padding: 16px;
    border-right: 1px solid ${theme.palette.primary[100]};
  }
  .MuiDataGrid-columnsContainer, .MuiDataGrid-cell {
    border-bottom: 1px solid ${theme.palette.primary[100]};
  }
  .MuiPaginationItem-root {
    border-radius: 0;
  }
  .MuiDataGrid-row .MuiDataGrid-cell{
    color: #161B32;
    display: flex;
    align-items: center;
    font-family: ${theme.typography.body1.fontFamily};
    font-size: 14px;
  }
  .MuiDataGrid-row .MuiDataGrid-cell:first-child{
    font-size: 16px;
    font-weight: 700;
    line-height: 150%;
  }
  .MuiDataGrid-row .MuiDataGrid-cell:last-child{
    border-right: 0;
  }
  .observation-row--even {
    background-color: #F0F3FF;
  }
  `,
};

const PatientHistoryDataGrid = (props: DataGridProps) => {

  const getRowClass = (params: GridRowClassNameParams) => {
    const evenRow = (params.indexRelativeToCurrentPage + 1) % 2 === 0;
    return evenRow ? "observation-row--even" : "";
  };

  return (
    <DataGrid
      css={gridStyles.table}
      autoHeight
      disableColumnMenu
      hideFooter
      getRowClassName={getRowClass}

      {...props}
    />
  );
};

export default PatientHistoryDataGrid;